@if (currencyExchangeUpdatedDate(); as updatedDate) {
  @if (pageType() === "detail") {
    <div class="tw-mt-1 tw-text-end tw-text-xs tw-italic">
      Tỷ giá được cập nhật lúc {{ updatedDate | date: "HH:mm" }} ngày
      {{ updatedDate | date: "dd/MM/yyyy" }} tại
      <a
        href="https://www.vietcombank.com.vn/vi-VN/KHCN/Cong-cu-Tien-ich/Ty-gia"
        target="_blank"
        class="tw-text-blue-600 hover:tw-text-blue-700"
      >
        Vietcombank
      </a>
    </div>
  }

  @if (pageType() === "success") {
    <div class="tw-mt-1 tw-text-center tw-text-xs tw-italic">
      Tỷ giá được cập nhật lúc {{ updatedDate | date: "HH:mm" }} ngày
      {{ updatedDate | date: "dd/MM/yyyy" }} tại
      <a
        href="https://www.vietcombank.com.vn/vi-VN/KHCN/Cong-cu-Tien-ich/Ty-gia"
        target="_blank"
        class="tw-text-blue-600 hover:tw-text-blue-700"
      >
        Vietcombank
      </a>
    </div>
  }

  @if (pageType() === "summary") {
    <div class="tw-text-start tw-text-yellow-400">
      Tỷ giá được cập nhật lúc {{ updatedDate | date: "HH:mm" }} ngày
      {{ updatedDate | date: "dd/MM/yyyy" }} tại
      <a
        href="https://www.vietcombank.com.vn/vi-VN/KHCN/Cong-cu-Tien-ich/Ty-gia"
        target="_blank"
        class="tw-text-cyan-400 hover:tw-text-cyan-300"
      >
        Vietcombank
      </a>
    </div>
  }
}
